/**
 * @generated SignedSource<<e2123bd29917d910668228ec9dc94778>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "DuplicateDocumentResult",
    "kind": "LinkedField",
    "name": "finishedDuplicateDocumentSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sequence",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "step",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "document",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "widgets",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "globalVariables",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinishedDuplicateDocumentSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinishedDuplicateDocumentSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e511627a96addd8c3dc7edd23e9bff2",
    "id": null,
    "metadata": {},
    "name": "FinishedDuplicateDocumentSubscription",
    "operationKind": "subscription",
    "text": "subscription FinishedDuplicateDocumentSubscription(\n  $filter: BaseSubscriptionInput!\n) {\n  finishedDuplicateDocumentSubscription(filter: $filter) {\n    sequence\n    id\n    step\n    document\n    widgets\n    globalVariables\n  }\n}\n"
  }
};
})();

node.hash = "fd10ffcedb65348cd614c6a44af51bb7";

export default node;
